"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isThemeVersionAction = exports.isThemeAction = void 0;
const themeActions = [
    'CREATE_NEW_THEME',
    'THEME_SET_DEFAULT',
    'EDIT_THEME',
    'DELETE_THEME',
];
const themeVersionActions = [
    'CREATE_NEW_THEME_VERSION',
    'DEACTIVATE_THEME_VERSION',
    'ACTIVATE_THEME_VERSION',
    'EDIT_THEME_VERSION',
    'PUBLISH_THEME_VERSION',
    'DELETE_THEME_VERSION',
];
const isThemeAction = (mightBeThemeAction) => themeActions.includes(mightBeThemeAction);
exports.isThemeAction = isThemeAction;
const isThemeVersionAction = (mightBeThemeVersionAction) => themeVersionActions.includes(mightBeThemeVersionAction);
exports.isThemeVersionAction = isThemeVersionAction;
//# sourceMappingURL=Actions.js.map